import { viewport } from '../../utils/viewport';

document.querySelectorAll('.hero__cta--region-report a').forEach((button) => {
  const downloadButton = document.querySelector('.region-hero__right .button');

  if (downloadButton) {
    viewport.observe(
      downloadButton,
      () => button.classList.add('hidden'),
      () => button.classList.remove('hidden')
    );
  } else {
    button.parentElement.removeChild(button);
  }
});